import { usePermission } from "../helpers/common";
import EquipmentSubList from "../components/equipment/EquipmentSubList";
import EquipmentGroupSubList from "../components/equipment-group/EquipmentGroupSubList";
import PersonSubList from "../components/person/PersonSubList";
import customerSubList from "../components/customer/CustomerSubList";
import CrewSubList from "../components/crew/CrewSubList";
import UserFarmSubList from "../components/farm/UserFarmSubList";
import GeoRegionSubList from "../components/geo-region/GeoRegionSubList";
import MessageNotify from "../components/chat/message/MessageNotify";
// import boardSvg from "../../assets/images/board.svg";
// import customerSvg from "../../assets/images/customer-white.svg";
import networkIcon from "../../assets/images/network-icon.svg";

export const getSideMenuList = () => {
  const allow = usePermission();
  const menus = [
    {
      path: "/map", title: "Home", icon: "icon icon-dashboard",
      visible: allow("map", "view")
    },
    {
      path: `/farm-monitor`, title: "Farm Dashboard", icon: "fa fa-line-chart",
      visible: allow("farm-dashboard", "view")
    },
    {
      path: "/dashboard", title: "Dashboard", name: "dashboard", icon: "fa fa-th-large",
      visible: allow("dashboard", "view")
    },
    {
      path: "/map/switchfarm", title: "Switch Farm", name: "switchfarm",
      icon: "icon icon-field", component: UserFarmSubList,
      visible: allow("farm-switch", "view")
    },
    {
      path: `/map/crew`, title: "Crews", name: "crew",
      icon: "fa fa-users", component: CrewSubList,
      visible: allow("crew", "view")
    },
    {
      path: `/map/eg`, title: "Equipment Groups", name: "eg",
      icon: "fa fa-truck", component: EquipmentGroupSubList,
      visible: allow("equipment-group", "view")
    },
    {
      path: `/map/equipment`, title: "Equipments", name: "equipment",
      icon: "fa fa-wrench", component: EquipmentSubList,
      visible: allow("equipment", "view")
    },
    {
      path: `/map/operator`, title: "Operators", name: "operator",
      icon: "fa fa-user", component: PersonSubList,
      visible: allow("operator", "view")
    },
    {
      path: `/map/customer`, title: "Customers", name: "customer",
      icon: 'icons icon-customers', component: customerSubList,
      visible: allow("customer", "view")
    },
    {
      path: `/map/georegion`, title: "Geo Regions", name: "georegion",
      icon: "icon icon-map-shape", component: GeoRegionSubList,
      visible: allow("geo-region", "view")
    },
    {
      path: "/device/list", title: "Devices", name: "device",
      icon: "fa fa-mobile fa-lg", visible: allow("device", "view")
    },
    // {
    //   path: "/network", title: "Network", name: "network",
    //   iconImg: networkIcon, visible: allow("add-network", "view")
    // },
    {
      path: "/scout", title: "Scout", name: "Scout", icon: "icon icon-scout",
      visible: allow("field-grouping", "view") || allow("scout-observation", "view")
    },
    {
      path: "/chat", title: "Chat", name: "chat",
      icon: "fa fa-comments-o", children: MessageNotify,
      visible: allow("chat", "view"), isBeta: false, isChat: true
    },
    // {
    //     path: "/report", title: "Report Generation", name: "report",
    //     icon: "fa fa-list-alt", visible: allow("report-generation", "create"), isBeta: true
    // },
    // {
    //     path: `/person/list`, title: "Person", name: "person", icon: "fa fa-user-plus",
    //     visible: allow("person", "view")
    // },
  ];

  return menus.filter(e => e.visible);
};

export const getSideMenuListEnd = () => {
  const allow = usePermission();
  const menus = [
    {
      path: `/device-console`,
      title: "Device Console",
      name: "hardware",
      icon: "icon icon-cpu",
      visible: allow("device-console", "view")
    },
    {
      path: `/network`,
      title: "Network",
      name: "network",
      iconImg: networkIcon,
      className: "users-button",
      visible: allow("add-network", "view"),
    },
    {
      path: `/board/list`,
      title: "Board Console",
      name: "board",
      icon: 'icons icon-brand-console',
      className: "users-button",
      visible: allow("board-console", "view"),
    },
    {
      path: `/qrcode`,
      title: "QR Code Generator",
      name: "qrcode",
      icon: 'fa fa-qrcode',
      className: "users-button",
      visible: allow("qrcode-generate", "view"),
    },
    {
      path: `/scale`,
      title: "Scale",
      name: "scale",
      icon: 'fa fa-road',
      className: "users-button",
      visible: allow("scale-weight", "view"),
    },
    {
      path: `/organization/list`,
      title: "Organization",
      name: "organization",
      icon: "fa fa-sitemap",
      className: "users-button",
      visible: allow("organization", "view"),
    },
    {
      path: `/users`,
      title: "User Management",
      name: "users",
      icon: "fa fa-address-card",
      className: "users-button",
      visible: allow("user", "view"),
    },
    // {
    //   path: "/settings",
    //   title: "Settings",
    //   name: "settings",
    //   className: "setting-button",
    //   icon: "fa fa-cog",
    //   visible: allow("settings", "view"),
    // },
    {
      path: "/organizationconfig",
      title: "Organization Configuration",
      name: "organizationconfig",
      className: "org-button",
      icon: "icon icon-theme",
      visible: allow("organization-configuration", "view"),
    },
    // {
    //   title: "Logout",
    //   icon: "fa fa-sign-out",
    //   onClick: async () => {
    //     await logoutFB();
    //     store.dispatch(logout());
    //   },
    //   className: "logout-button",
    //   visible: true,
    // },
  ];

  return menus.filter((e) => e.visible);
};
